<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer005">
<h2 id="sigil_toc_id_2"><span class="pagebreak" id="pagex" title="x"></span>InterVarsity Press<br/>
<br/></h2>
<p class="firstcenter"><i>Publisher</i></p>
<p class="center">Robert A. Fryling</p>
<p class="firstcenter"><i>Associate Publisher, Editorial</i></p>
<p class="center">Cindy Bunch</p>
<p class="firstcenter"><i>Editorial Director, Academic</i></p>
<p class="center">Daniel G. Reid</p>
<p class="firstcenter"><i>Production Director</i></p>
<p class="center">Anne Gerth</p>
<p class="body"><span class="pagebreak" id="pagexi" title="xi"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IVP.vue?5285c548